export default __webpack_public_path__ + "static/media/convictions.da47ea41.svg";